import Form from "./Form";
import Showcase from "./Showcase";
import ShowcaseCollection from "./ShowcaseCollection";

export default class ShowcaseContainer
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `${Form.selector()}__showcase-container`;

	getShowcaseCollection()
	{
		return new ShowcaseCollection(Array.from(this.el.querySelectorAll(Showcase.selector())).map(el => {
			return new Showcase(el);
		}));
	}

	setFromQueryResponse(response)
	{
		this.getShowcaseCollection().setFromQueryResponse(response);
	}

	showCategories()
	{
		this.getShowcaseCollection().filterByAffix("frequent").getShowcases()[0].hide();

		this.el.hidden = false;

		return true;
	}

	showFrequent()
	{
		this.getShowcaseCollection().hide();
		this.getShowcaseCollection().filterByAffix("frequent").getShowcases()[0].show();

		this.el.hidden = !this.getShowcaseCollection().filterByAffix("frequent").getShowcases()[0].getEdibleContainer().getEdibleCollection().getEdibles().length;

		return true;
	}
}
